import type { DocPage } from '../types'

export const smallworld: DocPage = {
  id: 'smallworld',
  title: 'Smallworld',
  description:
    'Connect Smallworld as a source using host, databases, ACE selection, and style import options.',
  category: 'Formats',
  sections: [
    { id: 'overview', title: 'Overview' },
    { id: 'connection', title: 'Connection fields' },
    { id: 'ace', title: 'ACE' },
    { id: 'styles', title: 'Style options' },
    { id: 'map', title: 'Map and filters' },
    { id: 'card', title: 'Connection card' },
  ],
  blocks: [
    {
      type: 'heading',
      level: 2,
      id: 'overview',
      text: 'Overview',
    },
    {
      type: 'paragraph',
      text: 'Smallworld appears in the format catalog as a Source-only format. You connect to a host, choose databases, optionally fetch and select an ACE, and can import Smallworld styles for downstream symbology workflows.',
    },
    {
      type: 'heading',
      level: 2,
      id: 'connection',
      text: 'Connection fields',
    },
    {
      type: 'table',
      headers: ['Field', 'UI label', 'Description'],
      rows: [
        ['Host', 'Host', 'Smallworld server host (default hint shown in the form).'],
        ['Databases', 'Database', 'Database selection for the connection card / model.'],
        ['Submit / Cancel', 'Submit / Cancel', 'Apply or dismiss the connection form.'],
      ],
    },
    {
      type: 'heading',
      level: 2,
      id: 'ace',
      text: 'ACE',
    },
    {
      type: 'table',
      headers: ['Control', 'Description'],
      rows: [
        ['Fetch ACE (optional)', 'Retrieve available ACE entries from the server.'],
        ['Select ACE (optional)', 'Choose an ACE from the list, or None.'],
        ['Only ACE-visible classes', 'Limit the model to ACE-visible classes when enabled.'],
        ['ACE classes', 'Summary: Visible only / All classes on the connection card.'],
      ],
    },
    {
      type: 'callout',
      variant: 'tip',
      title: 'When to use ACE filters',
      text: 'Enable Only ACE-visible classes when your operational view is ACE-scoped and you want the model tree to match what users see in Smallworld for that ACE.',
    },
    {
      type: 'heading',
      level: 2,
      id: 'styles',
      text: 'Style options',
    },
    {
      type: 'table',
      headers: ['Option', 'Description'],
      rows: [
        ['Display style / scale', 'Select the display style or scale context for symbology.'],
        ['Style group / drawing application', 'Choose the style group or drawing application.'],
        ['Import Smallworld styles', 'Enable importing Smallworld styles into the transfer/style pipeline.'],
        ['Style import (card)', 'Shows Enabled / Disabled on the connection summary.'],
      ],
    },
    {
      type: 'paragraph',
      text: 'Imported styles can feed later QML-oriented export paths when the Target format supports style export. See Styles import & export.',
    },
    {
      type: 'heading',
      level: 2,
      id: 'map',
      text: 'Map and filters',
    },
    {
      type: 'list',
      items: [
        'Source Smallworld supports spatial overview (Tree / Map) when the backend provides geometries.',
        'Use draw tools and inclusion modes as described in Map view & attribute table.',
        'Collection/attribute Filters still apply to limit the model tree.',
      ],
    },
    {
      type: 'heading',
      level: 2,
      id: 'card',
      text: 'Connection card',
    },
    {
      type: 'paragraph',
      text: 'The summary card surfaces ACE, Display style, Style group, Style import (Enabled/Disabled), ACE classes (Visible only / All classes), and Database for quick verification.',
    },
  ],
}
